var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1922 72.7074C26.0493 66.6345 22.7199 57.6693 22.4967 47.5974C22.4967 47.5695 22.4967 45.4305 22.4967 45.4026C22.7199 35.3307 26.0493 26.3655 31.1922 20.2926C37.8696 11.6343 47.7834 6.138 58.8504 6.138C65.658 6.138 72.0378 8.2212 77.4876 11.8389C69.3036 4.5105 58.5156 0.0465 46.6767 0C46.6209 0 46.5558 0 46.5 0C20.8227 0 0 20.8227 0 46.5C0 71.4426 19.6323 91.791 44.2866 92.9442C45.0213 92.9814 45.756 93 46.5 93C58.404 93 69.2664 88.5267 77.4876 81.1704C72.0378 84.7788 65.6673 86.862 58.8504 86.862C47.7834 86.862 37.8696 81.3657 31.1922 72.7074Z",
    fill: "url(#paint0_linear_101_10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1921 20.2925C35.4608 15.2519 40.9664 12.2201 46.9928 12.2201C60.5336 12.2201 71.4983 27.5651 71.4983 46.4999C71.4983 65.4347 60.5243 80.7797 46.9928 80.7797C40.9757 80.7797 35.4608 77.7386 31.1921 72.7073C37.8695 81.3656 47.7833 86.8619 58.8503 86.8619C65.6579 86.8619 72.0378 84.7787 77.4876 81.1703C87.0108 72.6515 93 60.2732 93 46.4999C93 32.7266 87.0108 20.3483 77.4876 11.8388C72.0378 8.22114 65.6672 6.13794 58.8503 6.13794C47.7833 6.13794 37.8695 11.6342 31.1921 20.2925Z",
    fill: "url(#paint1_linear_101_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_10",
    x1: 38.7459,
    y1: 1.51627,
    x2: 38.7459,
    y2: 91.6465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_10",
    x1: 62.0969,
    y1: 6.82853,
    x2: 62.0969,
    y2: 86.5443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.a4ef8ad8008f3e513e5ac65c1502a601.svg";
export { ForwardRef as ReactComponent };